import { useI18n } from "i18n";
import React from "react";
import { lazyLoad } from "helpers/lazyLoader";

const ConversationBroadcastContainer = lazyLoad(
  () => import("./ConversationBroadcastContainer"),
);

const ConversationBroadcast = () => {
  const { t } = useI18n();

  if (!ConversationBroadcastContainer) {
    return null;
  }

  return (
    <div>
      <React.Suspense fallback={<div>{t("loading")}</div>}>
        <ConversationBroadcastContainer />
      </React.Suspense>
    </div>
  );
};

export default ConversationBroadcast;
